export class GroupNotFoundError extends Error {
    constructor(groupId) {
        super(`Group ${groupId} not found`);
    }
}
//# sourceMappingURL=Types.js.map